__turbopack_context__.v({
  "sectionPadding": "styleConstants-module__CAUWUW__sectionPadding",
});
